import { mfaqServiceBaseUrl } from "@coworker/app/src/core/cloud-services/cloud-services.helper";
import { ApiEndpoints, BackendServices } from "./EndpointsTypes";
import { isChineseEnvironment } from "@coworker/reusable/helpers/devices";
import { getEnvironmentId } from "@coworker/reusable/helpers/environment";
import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { makeServiceHeaders } from "@coworker/app/src/core/hooks/fetch.helpers";

const isChina = isChineseEnvironment();

const MFAQ_SERVICE_URL = mfaqServiceBaseUrl(getEnvironmentId(), isChina);

export async function postRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices
) {
  return (await internalRequest(body, path, service, "POST")) as TResponse;
}

export async function putRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices
) {
  return (await internalRequest(body, path, service, "PUT")) as TResponse;
}

async function internalRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices,
  requestType: string
) {
  const response = await baseRequest(body, path, service, requestType);

  const contentType = response.headers.get("content-type");

  if (contentType && contentType.includes("application/json")) {
    const data = await response.json();
    return data as TResponse;
  } else {
    const responseText = await response.text();
    return responseText as TResponse;
  }
}

async function baseRequest<TBody>(
  body: TBody,
  path: ApiEndpoints,
  _service: BackendServices,
  requestType: string
) {
  const url = `${MFAQ_SERVICE_URL}/${path}`;
  const token = await getTokenAsync();
  if (!token || typeof token !== "string") {
    throw new Error("No token found");
  }
  const response = await fetch(url, {
    method: requestType,
    headers: await makeServiceHeaders(),
    body: JSON.stringify(body),
  });

  return response;
}
